import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';

export const useMigrateToInstachampRedirectCallback = () => {
  const facebookPage = useSelector(activeFacebookPageSelector);

  const instagramUsername =
    facebookPage?.availableInstagramAccountsData?.username;
  const fbPageName =
    facebookPage &&
    `${(facebookPage.name || '')
      .replace(/\s+/g, '-')
      .replace(/[^\w-]+/g, '')
      .replace(/-+/g, '-')
      .slice(0, 30)}~${facebookPage.id}`;

  return useCallback(() => {
    const url = instagramUsername
      ? `@${instagramUsername}`
      : fbPageName
      ? fbPageName
      : 'accounts';
    window.location.href = `/instachamp/${url}`;
  }, [facebookPage]);
};
